import {ChangeEvent, useRef, useState} from "react";
import axios from "axios";
import {PATHS_API} from "../../../enum";

const MAX_BYTES = 5 * 1024 * 1024;
const ACCEPT = "image/png,image/jpeg,image/webp,image/gif";

// Кнопка завантаження картинки на наш сервер. Повертає посилання /api/uploads/… через onUploaded.
// Тип і розмір ще раз перевіряє сервер (за вмістом файлу, а не за назвою).
const ImageUpload = ({ onUploaded, onError }: { onUploaded: (url: string) => void, onError: (message: string) => void }) => {
    const inputRef = useRef<HTMLInputElement>(null);
    const [uploading, setUploading] = useState(false);

    const upload = async (e: ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        e.target.value = ""; // щоб той самий файл можна було вибрати ще раз
        if (!file) return;
        if (file.size > MAX_BYTES) { onError("Картинка більша за 5 МБ"); return; }

        const body = new FormData();
        body.append("file", file);
        setUploading(true);
        try {
            const { data } = await axios.post(PATHS_API.ADMIN_UPLOADS, body, { withCredentials: true });
            onUploaded(data.url);
        } catch (err: any) {
            const message = err.response?.data?.message;
            onError(message === "PIN_REQUIRED" ? "Сесія адмінки закінчилась — оновіть сторінку й введіть PIN" : message || "Не вдалося завантажити картинку");
        } finally {
            setUploading(false);
        }
    };

    return (
        <>
            <input ref={inputRef} type="file" accept={ACCEPT} hidden onChange={upload} />
            <button type="button" className="adm-ghost-btn adm-upload-btn" onClick={() => inputRef.current?.click()} disabled={uploading}>
                {uploading ? "Завантаження..." : "⬆ Завантажити"}
            </button>
        </>
    );
};

export default ImageUpload;
